// src/app/services/settings/prospect-reads-api.ts
//
// Global Settings → Platform → Prospect reads.
//
// The switch that decides whether this deployment can take prospect reads (a
// standard production read at 3 reps, before a brand signs) and whether demo
// and prospect brands appear in the brand list for every login.
//
// Stored on the backend in app_config and read at runtime — no frontend env
// var, so sandbox and production each hold their own answer and neither needs
// a rebuild to change it. Admin-only on read and write; the backend answers
// 403 to anyone else.

import { apiFetch } from '@/api/api-fetch';

/** Where the live value came from.
 *  - `admin`                an admin stored this choice.
 *  - `environment_default`  nobody has chosen; this is what ENVIRONMENT implies
 *                           (on for sandbox/development, off for production).
 *  The page shows the difference because "on because this is a sandbox" and
 *  "on because somebody turned it on" are different facts about a deployment. */
export type ProspectReadsSource = 'admin' | 'environment_default';

export interface ProspectReadsState {
  enabled: boolean;
  source: ProspectReadsSource;
  /** e.g. "sandbox" | "production" — shown so an admin knows which box this is. */
  environment: string;
  /** What the switch would be if no admin had ever set it. */
  environment_default: boolean;
}

export async function fetchProspectReads(): Promise<ProspectReadsState> {
  return apiFetch<ProspectReadsState>('/admin/prospect-reads');
}

export async function updateProspectReads(
  enabled: boolean,
): Promise<ProspectReadsState> {
  return apiFetch<ProspectReadsState>('/admin/prospect-reads', {
    method: 'PUT',
    body: JSON.stringify({ enabled }),
  });
}
